// Configuración de URL para la API
// Usa la variable de entorno REACT_APP_API_URL o fallback según el entorno

const API_URL = process.env.REACT_APP_API_URL ||
  (window.location.hostname === 'localhost'
    ? 'http://localhost:5001'
    : 'https://www.exhibirte.com');

export default API_URL;
